import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "..";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
import useRouteName from "../../../hooks/useRouteName";

const utils = createTrackingUtils({
  name: "flights_split_bounds_us",
  stages: {
    us_round_trip_users: 1,
    main: 2,
    desktop: 3,
    mobile: 4,
    direct: 5,
    meta: 6,
    domestic: 7,
    international: 8
  },
  defaultStage: 1,
  goals: {
    cta_click: 1,
    change_depart_flight_click: 2,
    fd_fully_loaded: 3,
    negative_incremental_price_pay_now_click: 4,
    genius_offer_pay_now_click: 5
  }
});

export const useSplitBoundsCondition = () => {
  const { isAmerican, isRountrip } = useProfiler();

  const hasSplitBoundsCondition = isAmerican() && isRountrip();

  return {
    hasSplitBoundsCondition,
    isSplitBounds: hasSplitBoundsCondition && !!utils.trackWithDefaultStage()
  };
};

export const useTrackSplitBoundsStages = () => {
  const { hasSplitBoundsCondition } = useSplitBoundsCondition();
  const { isDesktop, isMobile, isDirect, isMeta, isInternational, isDomestic } = useProfiler();
  const routeName = useRouteName();
  const { stages } = utils;

  const isSearchResults =
    routeName === "searchresults" || routeName === "searchresults-outbound" || routeName === "searchresults-inbound";

  if (isSearchResults && hasSplitBoundsCondition) {
    stages.main();
    isDesktop() && stages.desktop();
    isMobile() && stages.mobile();
    isDirect() && stages.direct();
    isMeta() && stages.meta();
    isInternational() && stages.international();
    isDomestic() && stages.domestic();
  }
};

const key = "split_bounds_tracking";

const getTrackingData = (): Record<string, { price?: true; genius?: true }> => flightsSessionStore.get(key) || {};

const addTokenTrackingValue = (token: string, type: "price" | "genius") => {
  const data = getTrackingData();
  const tokenData = data[token] || {};

  flightsSessionStore.set(
    key,
    {
      ...data,
      [token]: { ...tokenData, [type]: true }
    },
    { ttl: "5m" }
  );
};
const getTokenTrackingValue = (token: string): { price?: true; genius?: true } | undefined => {
  const data = getTrackingData();
  return data[token];
};

export const splitBoundsTrackingStorage = {
  addValue: addTokenTrackingValue,
  getValue: getTokenTrackingValue
};

export default utils;
